import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import '../../css/Buttons.css';
import {config} from '../../constants';
import CustomStore from 'devextreme/data/custom_store';
import CircleSign from '../ui/CircleSign';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import { exportToExcel } from '../../utils/exportMethods'; 
import {deleteKey} from '../../utils/exportMethods';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import ConfirmationModal from '../ui/ConfirmationModal';
import {compare} from '../../utils/compare';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';

const url = config.url.URL; //"http://localhost:52344";

const vehicleUrl = `${url}/VehicleMicroservice`;
const vehicleUrlList = `${url}/VehicleMicroservice/List`;

var loadMyOptions = {};

const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

const customDataSource = new CustomStore({
  key: 'vehicleId',
  load: (loadOptions) => {
    loadMyOptions = { ...loadOptions };
    let requestBody = {};
    [
      'filter',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData'
    ].forEach((key) => {
      if (key in loadOptions && isNotEmpty(loadOptions[key])) {
        requestBody[key] = JSON.stringify(loadOptions[key]);
      }
    });

    return apiClient.post(`${vehicleUrlList}`, requestBody)
      .then(response => {
        const data = response.data;
        loadMyOptions.take = data.totalCount;
        return {
          data: data.data,
          totalCount: data.totalCount,
          summary: data.summary,
          groupCount: data.groupCount
        };
      })
      .catch((error) => {
        if (error === 'Unauthorized') {
          return; // Exit the componentDidMount function
        }
      });
  },
});

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}

const exportVehiclesToExcel = async (apiData) => {
  apiData.forEach(obj => {
    deleteKey(obj, 'vehicleId');
    deleteKey(obj, 'airportName');
    deleteKey(obj, 'subMediaId');
    deleteKey(obj, 'airportId');
    deleteKey(obj, 'publisherId');
    deleteKey(obj, 'geoElementId');
  });

  const headers = [
    { header: 'Vehicle', key: 'vehicleName', autoFit: true },
    { header: 'Country/Region', key: 'geoElementName', autoFit: true },
    { header: 'SubMedia', key: 'subMediaName', autoFit: true },
    { header: 'Publisher/Vendor', key: 'publisherName', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true },
  ];

  await exportToExcel(headers, apiData, 'vehicles_extract', 'Vehicles Extract');
};


class Vehicles extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];

        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          Countries: [],
          SubMedias: [],
          Publishers: [],
          Airports: [],
          ShowAirport: false,
          showPublisherMenu: true,
          showAirportMenu: true,
          showVehicleMenu: true,
          showPositionMenu: true,
          dataSource: null,
          currentPage: 0,
          pageSize: 5,
          pageSizes: [5,10,15] ,
          showPageSizeSelector: true,
          showInfo: true,
          showNavButtons: true,
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          fullscreen:false,
          selectedAirport: '',
          oldCheckValue: false,
          validation: true,
          nameVal:true,
          countryVal:true,
          submediaVal:true,
          airportVal:true,
          publisherVal:true,
          duplicatedValidation:true,
        };
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);

        this.confDiag = React.createRef();
        this.countryRef = React.createRef();
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }

      // to refresh our datagrid table and close all modals
      useRefresh = () => {
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }

      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
  
      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals = () => {
        const { state } = this.props.location;
        if (typeof state !== "undefined" && state != null) {
          if (state.showNewPopup) {
            history.push({ pathname: "/admin", state: { showNewPopup: false } });
          }
        }
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      };
      
  
      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
      }

    openModal = () => {     
      this.setState({
        ShowAirport: false, selectedAirport: '', Airports: [], showModal:true, validation:true, nameVal:true, countryVal:true, submediaVal:true, publisherVal:true, airportVal:true, duplicatedValidation: true
      });
    }

    onResfreshFromCountry = (event) => {
      this.fetchAirports(event.target.value);
    }

    onCreateVehicle =()=>{
    let name =this.refs.name.value.trim();
    let country =this.countryRef.current.value;
    let submedia =this.refs.submedia.value;
    let publisher =this.refs.publisher_vendor.value;

    if (name == ""){
      this.setState({nameVal: false})
    }else{
      this.setState({nameVal: true})
    }
    if (country == ""){
      this.setState({countryVal: false})
    }else{
      this.setState({countryVal: true})
    }
    if (submedia == ""){
      this.setState({submediaVal: false})
    }else{
      this.setState({submediaVal: true})
    }
    if (this.state.ShowAirport && this.refs.airport.value == ""){
      this.setState({airportVal: false})
    }else{
      this.setState({airportVal: true})
    }
    if (publisher == ""){
      this.setState({publisherVal: false})
    }else{
      this.setState({publisherVal: true})
    }

      if (name != "" && country != "" && submedia != "" && !(this.state.ShowAirport && this.refs.airport.value == "") && publisher != "") {
        let VehicleInfo = {
          Name: this.refs.name.value.trim(),
          SubMediaId: this.refs.submedia.value,
          GeoElementId: this.countryRef.current.value,
          AirportId: this.state.ShowAirport ? this.refs.airport.value : null,
          PublisherId: this.refs.publisher_vendor.value,
          IsEnabled: true
        };
        apiClient.post(`${url}/VehicleMicroservice`, VehicleInfo)
          .then(response => {
            const data = response.data;
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              toast.success('Vehicle has been created');
              this.doubleCloseModals();
              const { state } = this.props.location;
              if (typeof (state) !== 'undefined' && state != null) {
                if (state.showNewPopup) {
                  history.push({ pathname: "/admin", state: { 'showNewPopup': false } });
                }
              } else {
                this.useRefresh();
              }
            }
          });
      } else {
        this.setState({ validation: false })
        return;
      }
    }

    onEditVehicle=()=>{
    let name =this.refs.editname.value.trim();
    let publisher =this.refs.editpublisher_vendor.value;

    if (name == ""){
      this.setState({nameVal: false})
    }else{
      this.setState({nameVal: true})
    }
    if (this.state.ShowAirport && this.refs.editairport.value == ""){
      this.setState({airportVal: false})
    }else{
      this.setState({airportVal: true})
    }
    if (publisher == ""){
      this.setState({publisherVal: false})
    }else{
      this.setState({publisherVal: true})
    }
  
      if (name != "" && !(this.state.ShowAirport && this.refs.editairport.value == "") && publisher != "") {

        let VehicleInfo = {
          VehicleId: this.state.selectedRowIndex,
          Name: this.refs.editname.value.trim(),
          SubMediaId: this.refs.editsubmedia.value,
          GeoElementId: this.refs.editcountry.value,
          AirportId: this.state.ShowAirport ? this.refs.editairport.value : null,
          PublisherId: this.refs.editpublisher_vendor.value,
        };
        apiClient.put(`${url}/VehicleMicroservice`, VehicleInfo)
          .then(response => {
            const data = response.data;
            if (data) {
              if (data.statusCode == 400) {
                this.setState({ duplicatedValidation: false })
                return;
              } else {
                if (this.state.oldCheckValue != this.refs.chk_Is_Enabled.checked) {
                  this.confDiag.current.state.status = this.refs.chk_Is_Enabled.checked
                  this.confDiag.current.state.inEditMode = true;
                  this.confDiag.current.state.key = this.state.selectedRowIndex;
                  this.confDiag.current.handleOpenConfirmDialog();
                } else {
                  toast.success('Vehicle has been updated');
                  this.useRefresh();
                }
              }
            }
          });
      } else {
        this.setState({ validation: false })
        return;
      }
    }

    showDisabledEnabledToast = (value) => {
      if(!this.confDiag.current.state.inEditMode) {
        if(!value) {
          toast.success('Vehicle has been enabled');
        }
        else {
          toast.success('Vehicle has been disabled');
        }
      }
      else {
        if(value) {
          toast.success('Vehicle has been enabled');
        }
        else {
          toast.success('Vehicle has been disabled');
        }
      }
    }

  onAirportChanged = (event) => {
    this.setState({selectedAirport: event.target.value});
  }

  openEditModal = (e) => {
    this.setState({
      showEditModal: true,
      validation: true,
      nameVal: true,
      countryVal: true,
      submediaVal: true,
      airportVal: true,
      publisherVal: true,
      ShowAirport: false,
      selectedAirport: isNotEmpty(e.row.data.airportId) ? e.row.data.airportId : '',
      duplicatedValidation: true
    });
    this.fetchAirports(e.row.data.geoElementId);

    this.setState({selectedRowIndex: e.row.data.vehicleId});

    const enabledCountries = this.state.Countries.filter(obj => {return obj.isEnabled === true;});
    this.setState({Countries: enabledCountries});
    if (enabledCountries.find(x => x.geoElementId == e.row.data.geoElementId) == undefined)
    {
      var l_Countries = enabledCountries;
      l_Countries.push({
          geoElementId: e.row.data.geoElementId,
          name :e.row.data.geoElementName
      })
      l_Countries.sort(compare);
      this.setState({Countries: l_Countries});
    }

    const enabledPublishers = this.state.Publishers.filter(obj => {return obj.isEnabled === true;});
    this.setState({Publishers: enabledPublishers});
    if (enabledPublishers.find(x => x.publisherId == e.row.data.publisherId) == undefined)
    {
      var l_Publishers = enabledPublishers;
      l_Publishers.push( {
          publisherId: e.row.data.publisherId,
          name :e.row.data.publisherName
      })
      l_Publishers.sort(compare);
      this.setState({Publishers: l_Publishers})
    }

    this.refs.editname.value = e.row.data.vehicleName;
    this.refs.editcountry.value = e.row.data.geoElementId;
    this.refs.editsubmedia.value = e.row.data.subMediaId;
    this.refs.editpublisher_vendor.value = e.row.data.publisherId;
    this.refs.chk_Is_Enabled.checked = e.row.data.isEnabled;
    if (e.row.data.subMediaName == 'Airports')
    {
      this.setState({ShowAirport: true});
    }
    else
    {
      this.setState({ShowAirport: false});
    }

    this.setState({oldCheckValue: e.row.data.isEnabled});
  }
  
  onExportToExcel = () => {
    let requestBody = {};
      [
        'filter',
        'searchOperation',
        'searchValue',
        'select',
        'sort',
        'skip',
        'take',
        'totalSummary',
        'userData'
      ].forEach((key) => {
        if (key in loadMyOptions && isNotEmpty(loadMyOptions[key])) {
          requestBody[key] = JSON.stringify(loadMyOptions[key]);
        }
      });

    apiClient.post(`${vehicleUrlList}`, requestBody)
      .then(response => {
        const data = response.data;
        if (data) {
          exportVehiclesToExcel(data.data);
          toast.success('Vehicles Excel export file has been generated');
        }
      });
  }

  checkIfAirport = (event) => {
    if(event.target.options[event.target.selectedIndex].text == 'Airports'){
      this.setState({ShowAirport: true});
    }else{
      this.setState({ShowAirport: false});
    }
  }

  fetchCountries() {
    let initialCountries = [];
    apiClient(`${url}/GeoElementMicroservice/countriesadmindropdown`)
      .then(response => {
        const data = response.data;
        initialCountries = data;
        this.setState({
          Countries: initialCountries,
        });
      }).catch((error) => {
        if (error === 'Unauthorized') {
          return; // Exit the componentDidMount function
        }
        console.error(error);
      });
  }

  fetchSubMedias() {
    let initialSubMedias = [];
    apiClient.get(`${url}/SubMediaMicroservice`)
      .then(response => {
        const data = response.data;
        initialSubMedias = data;
        this.setState({
          SubMedias: initialSubMedias
        })
      }).catch((error) => {
        if (error === 'Unauthorized') {
          return; // Exit the componentDidMount function
        }
      });
  }

  fetchPublishers() {
    let initialPublishers = [];
    apiClient.get(`${url}/PublisherMicroservice/dropdowns`)
      .then(response => {
        const data = response.data;
        initialPublishers = data;
        this.setState({
          Publishers: initialPublishers,
        });
      });
  }

  fetchAirports(countryId) {
    let initialAirports = [];
    if (isNotEmpty(countryId))
    {
      let airportURL = `${url}/AirportMicroservice/dropdown/`;
      let airportURLWithCountry = airportURL.concat(countryId);
      apiClient.get(`${airportURLWithCountry}`)
        .then(response => {
          const data = response.data;
          initialAirports = data.filter(x => x.isEnabled == true || x.airportId == this.state.selectedAirport);
          this.setState({Airports: initialAirports});
        });
    }
    else
    {
      this.setState({Airports: initialAirports});
    }
  }

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      showAirportMenu: decoded.can_manage_airport_names === "true",
      showPublisherMenu: decoded.can_manage_publishers_vendors === "true",
      showVehicleMenu: decoded.can_manage_vehicles === "true",
      showPositionMenu: decoded.can_manage_positions === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true"
    });
    const { state } = this.props.location;
    if (typeof(state) !== 'undefined' && state != null) {
    if(state.showNewPopup){
      this.setState({showModal:true});
    }
  }
    this.fetchCountries();
    this.fetchSubMedias();
    this.fetchPublishers();    
  }

  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
  }

  Checkisdisabled = (e) =>{
  return !e.row.data.isEnabled ;
  }

  onDelete = (e) => {
    this.confDiag.current.state.key = e.row.data.vehicleId;
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleOpenConfirmDialog();
  }

  getQueryString = () => (
    `${url}/VehicleMicroservice/${this.state.pageSize}/${this.state.pageSize * this.state.currentPage}`
  );

  handleOptionChange(e) {
    if(e.fullName === 'paging.pageSize') {
        this.setState({
            pageSize: e.value 
        });
    }
    if(e.fullName === 'paging.pageIndex') {
        this.setState({
            currentPage: e.value 
        });
    }
}

  render() {
    let l_countries = this.state.Countries;
    let optionCountries = l_countries.map((country) =>
        <option value={country.geoElementId}>{country.name}</option>
    );
    let optionEnabledCountries = l_countries
    .filter(country => country.isEnabled)
    .map(country =>
        <option value={country.geoElementId} key={country.geoElementId}>
            {country.name}
        </option>
    );
    let l_SubMedias = this.state.SubMedias;
    let optionSubMediasAll = l_SubMedias.map((submedia) =>
        <option value={submedia.subMediaId}>{submedia.name}</option>
    );
    let optionSubMediasEnabled = l_SubMedias
    .filter(submedia => submedia.isEnabled)
    .map(({ subMediaId, name }) => (
      <option key={subMediaId} value={subMediaId}>
        {name}
      </option>
    ));
  
    
    let l_Publishers = this.state.Publishers;
    let optionPublishers = l_Publishers.map((publisher) =>
        <option value={publisher.publisherId}>{publisher.name}</option>
    );
    
    let l_Airports = this.state.Airports;
    let optionAirports = l_Airports.map((Airport) =>
        <option value={Airport.airportId}>{Airport.name}</option>
    );

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "vehicleName", caption: "Vehicle", width: "25%", alignment: "left" },
      { dataField: "geoElementName", caption: "Country/Region", width: "25%", alignment: "left" },
      { dataField: "subMediaName", caption: "SubMedia", width: "25%"},
      { dataField: "publisherName", caption: "Publisher/Vendor", width: "25%"},
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>            
           {'Media References > Vehicles Management'}
          </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Vehicle</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
        <div className="div-body-submenu">
            <div className={this.state.showPublisherMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('publishersvendors')} >              
              <div class="div-submenu-label">
                    <label>Publishers/Vendors</label>
              </div> 
            </div>
            <div className={this.state.showAirportMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('airports')} >              
              <div class="div-submenu-label">
                    <label>Airports</label>
              </div> 
            </div>
            <div  className={this.state.showVehicleMenu ? "div-submenu-link active" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('vehicles')} >              
              <div class="div-submenu-label">
                    <label>Vehicles</label>
              </div>               
            </div>
            <div  className={this.state.showPositionMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('positions')} >              
              <div class="div-submenu-label">
                <label>Positions</label>
              </div>               
            </div>
          </div>
        <div  className="div-padding-20 div-grid-result">
           <CustomDataGrid
              dataSource={customDataSource}
              keyExpr="vehicleId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
              remoteOperations={true}
            />
      </div>
      </div>
      
      <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen} className="md-scroll">
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Vehicle</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body> 
          {!this.state.validation && this.state.duplicatedValidation &&  <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Vehicle form is not allowed</p></Row>  }  
          {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Vehicle already exists, your updates cannot be saved. Please go back to Vehicles Management list to edit the corresponding form.</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="name" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>

          <Row>
           <Form.Group className="mb-3 col-md-12" controlId="country">
              <Form.Label className={`${this.state.countryVal ? "normal-title" : "validation-title"} font-size-12`}>Country/Region  <CircleSign/></Form.Label>   
              <Form.Control
                className={`select-placeholder ${!this.state.countryVal && "validation-control"}`}
                placeholder="Country/Region"
                ref={this.countryRef}
                as="select"
                required
                defaultValue=""
                onChange={this.onResfreshFromCountry}
                >
                  <option value="" hidden>Country/Region</option>
                  {optionEnabledCountries}
                </Form.Control>
              {!this.state.countryVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
      
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="submedia">
              <Form.Label className={`${this.state.submediaVal ? "normal-title" : "validation-title"} font-size-12`}>SubMedia  <CircleSign/></Form.Label>   
              <Form.Control 
                className={`select-placeholder ${!this.state.submediaVal && "validation-control"}`}
                placeholder="SubMedia" 
                ref="submedia"
                as="select" 
                required 
                defaultValue=""
                onChange={this.checkIfAirport} 
                >
                <option value="" hidden>SubMedia</option>
                {optionSubMediasEnabled}
              </Form.Control>
              {!this.state.submediaVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>

          {this.state.ShowAirport &&
          (   
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="airport">
              <Form.Label className={`${this.state.airportVal ? "normal-title" : "validation-title"} font-size-12`}>Airport  <CircleSign/></Form.Label>   
              <Form.Control  
                className={`select-placeholder ${!this.state.airportVal && "validation-control"}`}
                placeholder="Airport" 
                ref="airport"
                as="select" 
                required 
                defaultValue=""
                >
                <option value="" hidden>Airport</option>
                {optionAirports}
              </Form.Control>
              {!this.state.airportVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          )}   

          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="publisher_vendor">
              <Form.Label className={`${this.state.publisherVal ? "normal-title" : "validation-title"} font-size-12`}>Publisher/Vendor  <CircleSign/></Form.Label>   
              <Form.Control  
                className={`select-placeholder ${!this.state.publisherVal && "validation-control"}`}
                placeholder="Publisher/Vendor" 
                ref="publisher_vendor"
                as="select" 
                required 
                defaultValue=""
                >
                <option value="" hidden>Publisher/Vendor</option>
                {optionPublishers}
              </Form.Control>
              {!this.state.publisherVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateVehicle}>
            Create Vehicle
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen} className="md-scroll">
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Vehicle</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body> 
          {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Vehicle form is not allowed</p></Row>  }   
          {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Vehicle already exists, your updates cannot be saved. Please go back to Vehicles Management list to edit the corresponding form.</p></Row>  } 

          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="edit_Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="editname" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>

          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="edit_country">
              <Form.Label className='font-size-12'>Country/Region  <CircleSign/></Form.Label>   
              <Form.Control
                className="select-placeholder"
                placeholder="Country/Region" 
                ref="editcountry"
                as="select" 
                required 
                readOnly 
                disabled="true"
                defaultValue=""
                >
                <option value="" hidden>Country/Region</option>
                {optionCountries}
              </Form.Control>
            </Form.Group>
          </Row>      
      
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="edit_submedia">
              <Form.Label className='font-size-12'>SubMedia  <CircleSign/></Form.Label>   
              <Form.Control  
                placeholder="SubMedia" 
                ref="editsubmedia"as="select" required readOnly disabled="true">
                <option value="" hidden>SubMedia</option>
                {optionSubMediasAll}
              </Form.Control>
            </Form.Group>
          </Row>

          {this.state.ShowAirport && 
          (
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="edit_airport">
              <Form.Label className={`${this.state.airportVal ? "normal-title" : "validation-title"} font-size-12`}>Airport  <CircleSign/></Form.Label>   
              <Form.Control placeholder="Airport" ref="editairport" as="select" required className={`${!this.state.airportVal && "validation-control"}`}
                defaultValue="" value={this.state.selectedAirport} onChange={this.onAirportChanged}>
                <option value="" hidden>Airport</option>
                {optionAirports}
              </Form.Control>
              {!this.state.airportVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          )}

          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="edit_publisher_vendor">
              <Form.Label className={`${this.state.publisherVal ? "normal-title" : "validation-title"} font-size-12`}>Publisher/Vendor  <CircleSign/></Form.Label>   
              <Form.Control placeholder="Publisher/Vendor" ref="editpublisher_vendor" as="select" required className={`${!this.state.publisherVal && "validation-control"}`}>
                <option value="" hidden>Publisher/Vendor</option>
                {optionPublishers}
              </Form.Control>
              {!this.state.publisherVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>   

          <Row>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" ref="chk_Is_Enabled" label="Is Enabled" />
            </Form.Group>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditVehicle}>
            Update Vehicle
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal>

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} microserviceName="VehicleMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} title="Can't enable Vehicle" msg="You can't enable this Vehicle because it is linked to a disabled country. Please modify the country selected or go to Country/Region administration to enable the current one."></ConfirmDialog>
      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }

    onShowFilterRowChanged(e) {
      this.setState({
        showFilterRow: e.value
      });
      this.clearFilter();
    }

    onShowHeaderFilterChanged(e) {
      this.setState({
        showHeaderFilter: e.value
      });
      this.clearFilter();
    }

    onCurrentFilterChanged(e) {
      this.setState({
        currentFilter: e.value
      });
    }

    clearFilter() {
      this.dataGrid.clearFilter();
    }
}

export default Vehicles;